/* eslint-disable */
import chooseUserDialog from '../components/dialog/chooseUserDialog.vue'

export function checkUserName({
  code,
  data = [{ userId: '', userName: '', accountType: '' }],
  callback = ({userId = ''}) => {},
  onCancel = () => {},
}) {
  if (code === 733) {
    vm.$store.dispatch('home/showGlobalDialog', {
      title: vm.$t('common_dialog_tips_title'),
      component: chooseUserDialog,
      componentData: {
        data,
        callback,
        onCancel,
      }
    })
  }
}
